import _ from 'lodash';
import commonConfig from '../configs/common.json';
import envConfig from './config.json';

const config = _.merge(commonConfig, envConfig);

config.isFeatureEnabled = key => ((!_.isUndefined(key)) ? _.get(config.features, key) : true);

export default config;
